export default function Hero() {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background with Logo */}
      <div className="absolute inset-0 bg-gradient-to-br from-black via-gray-900 to-black">
        <img
          src="https://static.readdy.ai/image/74809ee30fca19c1acffe2fc12cb4256/24151a9b24e2ba5e0b07eb7354fcf6e7.jpeg"
          alt="A&H Junk Removal Logo"
          className="w-full h-full object-contain object-center opacity-30 mix-blend-lighten"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/80"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-black/70"></div>
      </div>

      {/* Animated Grid Lines */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(to right, #D4AF37 1px, transparent 1px), linear-gradient(to bottom, #D4AF37 1px, transparent 1px)',
          backgroundSize: '60px 60px'
        }}></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 w-full">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-full mb-8">
            <span className="w-2 h-2 bg-[#D4AF37] rounded-full animate-pulse"></span>
            <span className="text-[#D4AF37] text-sm font-medium tracking-wider">
              FAMILY OWNED & OPERATED
            </span>
          </div>

          {/* Main Heading */}
          <h2 className="font-['Orbitron'] text-5xl sm:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
            <span className="font-['Cinzel'] tracking-tight">A</span>&H
            <span className="block text-[#D4AF37]">JUNK REMOV<span className="font-['Cinzel'] tracking-tight">A</span>L</span>
          </h2>

          {/* Subheading */}
          <p className="text-xl sm:text-2xl text-gray-300 mb-4 font-light">
            Father & Son. Family Values. Professional Service.
          </p>
          <p className="text-gray-400 text-lg mb-10 max-w-xl">
            We haul away your junk with honesty, hard work, and a commitment to our community. 
            Fast, reliable, and eco-friendly disposal you can trust.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <a
              href="#contact"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#D4AF37] text-black font-bold rounded-lg hover:bg-[#E5C158] transition-all hover:shadow-lg hover:shadow-[#D4AF37]/30 cursor-pointer whitespace-nowrap"
            >
              <span>GET FREE QUOTE</span>
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="tel:+19514911655"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 border-2 border-white/30 text-white font-semibold rounded-lg hover:border-[#D4AF37] hover:text-[#D4AF37] transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line"></i>
              <span>CALL NOW</span>
            </a>
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-4">
            <span className="text-gray-500 text-sm">Follow Us:</span>
            <a
              href="https://www.facebook.com/marketplace/item/1188411236700848/?mibextid=wwXIfr"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center border border-gray-700 rounded-full text-gray-400 hover:border-[#D4AF37] hover:text-[#D4AF37] transition-all cursor-pointer"
            >
              <i className="ri-facebook-fill text-lg"></i>
            </a>
            <a
              href="https://instagram.com/a.hjunkremoval"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center border border-gray-700 rounded-full text-gray-400 hover:border-[#D4AF37] hover:text-[#D4AF37] transition-all cursor-pointer"
            >
              <i className="ri-instagram-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-gray-500 text-xs tracking-widest">SCROLL</span>
        <i className="ri-arrow-down-line text-[#D4AF37]"></i>
      </div>

      {/* Decorative Corner Elements */}
      <div className="absolute top-24 right-8 w-32 h-32 border-t-2 border-r-2 border-[#D4AF37]/30 hidden lg:block"></div>
      <div className="absolute bottom-24 left-8 w-32 h-32 border-b-2 border-l-2 border-[#D4AF37]/30 hidden lg:block"></div>
    </section>
  );
}
